import { Icons } from '@/components/Shares/Icons';
import { PrimeSwitch } from '@/components/Shares/PrimeSwitch';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Group, Stack, Text, rem } from '@mantine/core';
export const PreferenceMarketingCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }}>
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={10} className={gunterzBold.className}>
        {i18n._('Marketing')}
      </Text>

      <Group mt={24} justify="space-between">
        <Group c="var(--text-dark)">
          <Icons className="icon-pr-line-bell" fontSize={25} />
          <Stack gap={0}>
            <Text fz="xs" tt="uppercase" fw={700} c="inherit">
              {i18n._('email marketing')}
            </Text>
            <Text fz={{
            base: rem(10),
            sm: 'xs'
          }} c="inherit" w={{
            base: 233,
            sm: 479
          }}>
              {i18n._('Receive notifications for offers and promotions. Critical information regarding your account will always be sent')}
            </Text>
          </Stack>
        </Group>
        <PrimeSwitch />
      </Group>
    </Card>;
};